import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface DocumentIconProps {
  documentType: string;
}

const StyledIcon = styled.div`
  .icon {
    max-width: 25px;

    svg {
      font-size: 1.2rem;
    }
  }
`

const documentTypeIcons: Record<string, ReactNode> = {
  html: <img className="icon" src="/assets/icons/html_icon.png" alt="HTML Icon" />,
  docx: <img className="icon" src="/assets/icons/docx_icon.png" alt="DOCX Icon" />,
  pdf: <img className="icon" src="/assets/icons/pdf_icon.png" alt="DOCX Icon" />,
  email: <img className="icon" src="/assets/icons/html_icon.png" alt="Email Icon" />,
  pptx: <img className="icon" src="/assets/icons/pptx_icon.png" alt="Pptx Icon" />,
};

export const DocumentIcon: FC<DocumentIconProps> = ({ documentType }) => {
  const Icon = documentTypeIcons[documentType];

  // Ensure returning a valid React element
  return <StyledIcon>{Icon}</StyledIcon>;
};
